import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import RotatePDFImagesListScreen from "./RotatePDFImagesListScreen";
import { BASE_URL } from "../Config";

function RotatePDFMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "Rotate PDF Pages For Free" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/rotate_pdf", title: "Flip PDF Pages Online Free" },
    data2: { link: "/rotate_pdf", title: "Rotate PDF Pages Online Free" },
    data3: { link: "/rotate_pdf", title: "Flip & Rotate PDF Pages" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Rotate PDF pages online easily. Turn, flip, or fix PDF page orientation quickly with our fast, secure, and simple PDF rotate tool."
      ></meta>
      <meta
        name="keywords"
        content="rotate pdf, rotate pdf online, rotate pdf pages, pdf page rotation, flip pdf pages, fix pdf orientation, pdf rotate tool, rotate pdf file, change pdf orientation, pdf editor online, pdf management tool, rotate scanned pdf, pdf page editor, rotate pdf free, rotate document pdf, rotate pdf page images, flip pdf pages, pdf page flipper, pdf flipper, flip pdf documents, mirror pdf, mirror pdf pages,"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <RotatePDFImagesListScreen title={title}></RotatePDFImagesListScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={false}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our Rotate PDF Pages website provides a fast, secure, and easy-to-use solution to rotate and flip PDF documents both offline and online. Designed for students, professionals, and businesses, this powerful tool allows users to rotate PDF, rotate PDF pages, and flip PDF pages with precision while maintaining the original document quality. With offline functionality, all processing happens directly on your device, ensuring complete privacy and data security without uploading files to external servers. When internet access is available, users can easily rotate PDF pages online for free using a smooth, browser-based interface for instant results. Whether you need to correct scanned documents, adjust page orientation, or flip PDF pages horizontally or vertically, this tool delivers accurate and professional output. The platform also supports flip PDF pages free, making it accessible for everyday document needs without complicated setup or subscriptions. Using advanced page rotation technology, the tool preserves text clarity, images, and formatting during rotation and flipping. Compatible with desktop and mobile devices, this website helps users fix page orientation issues, improve document readability, and prepare PDFs for printing, sharing, or submission. If you are searching for a reliable solution to rotate PDF, flip PDF, rotate PDF pages, flip PDF pages, rotate PDF pages online for free, or flip PDF pages free both offline and online, this platform offers a complete, user-friendly PDF management experience." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Rotate",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Rotate PDF Pages Tool"
            why_use={[
              {
                title: "Fix Incorrect PDF Page Orientation",
                description:
                  "Scanned or imported documents often appear sideways or upside down. A rotate PDF pages tool helps correct orientation and makes PDFs easy to read.",
              },
              {
                title: "Improve Document Readability",
                description:
                  "Properly oriented pages enhance clarity and viewing experience. Using rotate PDF or flip PDF features ensures text and images display correctly.",
              },
              {
                title: "Prepare PDFs for Printing",
                description:
                  "Incorrect orientation can cause printing issues. With rotate PDF pages online for free, you can adjust pages before printing to avoid errors.",
              },
              {
                title: "Flip PDF Pages Horizontally or Vertically",
                description:
                  "Some documents require mirrored layouts. A flip PDF pages free tool allows horizontal or vertical flipping without affecting document quality.",
              },
              {
                title: "Save Time on Document Editing",
                description:
                  "Instead of rescanning or recreating files, a rotate PDF pages tool fixes orientation problems instantly.",
              },
              {
                title: "Preserve Original Quality",
                description:
                  "Advanced rotate PDF and flip PDF tools maintain text clarity and image resolution, keeping documents professional.",
              },
              {
                title: "Ideal for Scanned and Merged PDFs",
                description:
                  "Scanned and merged PDFs often contain mixed orientations. Rotate PDF pages tools quickly correct these inconsistencies.",
              },
              {
                title: "Work Offline for Better Privacy",
                description:
                  "An offline rotate PDF pages tool processes files locally, ensuring data privacy without uploading documents online.",
              },
              {
                title: "Rotate PDF Pages Online Anytime",
                description:
                  "With rotate PDF pages online for free, users can adjust PDF orientation from any device without installing software.",
              },
            ]}
          />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${6504000491}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default RotatePDFMain;
